export enum ExternalSourceType
{
    Bolt,
    Xpm,
    APS,
    SuperMate
}